// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"14c289c5","453":"04310c03"}[chunkId] + ".chunk.js";
};